import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "7",
  navbarHook: "mounted",
  loadMethods: ["fetchQrInfo", "fetchPending", "fetchHistory"],
});
